import React from 'react';

export default function ChangeTemplateConfirmationModal({
  isOpen,
  weekdayName,
  onConfirm,
  onCancel,
  isLoading = false,
}) {
  React.useEffect(() => {
    if (!isOpen) return;
    const handleEscape = (e) => {
      if (e.key === 'Escape' && !isLoading) onCancel();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onCancel, isLoading]);

  if (!isOpen) return null;

  const dayLabel = weekdayName ? ` for ${weekdayName}` : '';

  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
      onClick={onCancel}
      role="dialog"
      aria-modal="true"
      aria-labelledby="change-template-title"
    >
      <div
        className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="change-template-title" className="text-lg font-bold text-gray-900 mb-2">
          Change template{dayLabel}?
        </h3>
        <p className="text-sm text-gray-600 mb-6">
          The assigned workouts and any exercise edits for this day will be lost. You will need to
          choose a new template and set up exercises again.
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-orange-primary hover:bg-orange-600 rounded-lg disabled:opacity-50"
          >
            {isLoading ? 'Please wait…' : 'Choose template'}
          </button>
        </div>
      </div>
    </div>
  );
}
